import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MessageError } from 'autogen/translation-keys/trans-website-comai';
import HighlightedText from 'components/generic/HighlightedText';

const StyledHightlightedText = styled(HighlightedText)`
    margin-bottom: ${({ theme }) => theme.Spacing12};
`;

export default function ErrorMessage() {
    const { t } = useTranslation();

    return <StyledHightlightedText color="ColorSystemNegative1">{t(MessageError)}</StyledHightlightedText>;
}
